var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        {
          show: _vm.getIsShowPopupRequiredLogin,
          "d-block": _vm.getIsShowPopupRequiredLogin,
        },
      ],
      style: { display: _vm.getIsShowPopupRequiredLogin ? "block" : "none" },
      attrs: { tabindex: "-1" },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-promotion" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon close",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleClosePopupRequiredLogin },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("login.popupRequiredLogin.body.text1"))),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "lead",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("login.popupRequiredLogin.body.text2")
                ),
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: { type: "button" },
                on: { click: _vm.handleOpenPopupRegister },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "login.popupRequiredLogin.footer.signUpButtonTitle"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.handleOpenPopupLogin },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "login.popupRequiredLogin.footer.signInButtonTitle"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }